<template>
  <div class="index-more">
    <h2>{{ element.titleBarName }}</h2>
    <div class="index-more-swiper-inner">
      <div
        class="index-more-item index-more-item-bg1"
        v-for="(item, index) in childItem.propsValue.data"
        :key="index"
      >
        <a>
          <img width="100%" height="100%" :src="item.customField3" />
          <div class="icon icon-1">
            <img src="" />
          </div>
        </a>
        <span>{{ item.customField1 }}</span>
        <p style="height: 1.4rem">
          {{ item.customField2 }}
        </p>
        <a class="index-more-btn">{{ item.customField4.text }} →</a>
      </div>
    </div>
  </div>
</template>

<script>
let buttonDataObject = {
  text: "按钮",
  beforeClick: {
    type: 0, // 0 直接访问使用， 1 填写表单后有效
    form: "", // 表单ID，按钮点击需填写表单
    formtime: "无", // 表单有效期  无 一天 七天 永久
  },
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: "",
  },
};
export default {
  name: "MkXiangguanchanpinPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text",
        },
        {
          code: "customField2",
          label: "描述",
          type: "text",
        },
        {
          code: "customField3",
          label: "图片",
          type: "image",
          width: 376,
          height: 188,
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button",
        },
      ],
      data: [
        {
          customField1: "YonBIP | 友费控",
          customField2: "智能采集填报、智能合规管控、多维费用 分析...",
          customField3: "https://www.yonyou.com/yingxiao/jinrong/cyy/images/index/more-img1.jpg",
          customField4: JSON.parse(JSON.stringify(buttonDataObject)),
        },
        {
          customField1: "YonBIP | 友商旅",
          customField2: "提供商旅平台、聚合商旅生态、企业数智 链接...",
          customField3: "https://www.yonyou.com/yingxiao/jinrong/cyy/images/index/img-ysl.png",
          customField4: JSON.parse(JSON.stringify(buttonDataObject)),
        },
        {
          customField1: "YonBIP | 银企联",
          customField2: "连接千万银行、协作百万企业、管理万种 交易...",
          customField3: "https://www.yonyou.com/yingxiao/jinrong/cyy/images/index/img-czyB.png",
          customField4: JSON.parse(JSON.stringify(buttonDataObject)),
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
/* 更多相关产品 */
.index-more {
  background: #ffffff;
  height: 320px;
  width: 100%;
  overflow: hidden;
  h2 {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #e31924;
    letter-spacing: 0;
    text-align: center;
    padding: 18px 0 13px 0;
  }
}
.index-more-item {
  width: 200px;
  height: 235px;
  box-shadow: 0px 5px 15px 0px rgba(175, 175, 175, 0.1);
  border-radius: 4px;
  transition: all 0.3s ease-in;
}
.index-more-item > a {
  display: block;
  height: 105px;
}
.index-more-item > a .icon {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.index-more-item > a .icon-1 {
  width: 61px;
}
.index-more-item > a .icon-2 {
  width: 70px;
}

.index-more-item > a .icon-1 img {
  position: relative;
  width: 100%;
  bottom: -10px;
  right: -14px;
}
.index-more-item > a .icon-2 img {
  position: relative;
  width: 100%;
  bottom: -19px;
  right: -18px;
}

.index-more-item span {
  display: inline-block;
  font-size: 14px;
  line-height: 1.02;
  font-weight: bolder;
  color: #e31924;
  margin: 11px 0;
  padding-left: 15px;
}
.index-more-item p {
  font-size: 10px;
  line-height: 15px;
  color: #6c6c6c;
  padding: 0 7px 0 15px;
}
.index-more-item .index-more-btn {
  font-size: 10px;
  line-height: 11px;
  color: #454343;
  padding-top: 30px;
  padding-left: 15px;
}
.index-more-item .index-more-btn:hover {
  color: #e31924;
}
.index-more-item:hover h3 {
  color: #dd0b17;
}
.index-more-swiper-inner {
  padding-bottom: 15px;
  width: 800px;
  height: 100%;
  display: flex;
}
.index-more-swiper-inner > .swiper-container > .swiper-wrapper > .swiper-slide {
  width: 20px !important;
  height: 235px;
  box-shadow: 0px 5px 15px 0px rgba(175, 175, 175, 0.1);
  border-radius: 4px;
  transition: all 0.3s ease-in;
}
</style>
